import React from "react";
import "./belowcontent.css";
import { useEffect,useState } from "react";

const features = [
  {
    title: "AI Surveillance",
    description: "Real-time monitoring using advanced AI vision and detection."
  },
  {
    title: "Face Recognition",
    description: "Accurate facial identification with secure database matching."
  },
  {
    title: "Tele Operation",
    description: "Designed for Human-Operated Control,enabling remote navigation."
  },
  {
    title: "Language Alerts",
    description: "Public announcements supported in multiple languages."
  },
  {
    title: "Violence Detection",
    description: "Real-time detection and analysis of Violence in public."
  },
  {
    title: "Voice Assistant",  
    description: "Voice-enabled interaction for guidance, and real-time responses."
  }
];

const BelowcontentPage = () => {
  const bubbles = Array.from({ length: 10 });
  const [activeTextSlide, setActiveTextSlide] = useState(0);

  useEffect(() => {
  const interval = setInterval(() => {
    setActiveTextSlide(prev => (prev === 0 ? 1 : 0));
  }, 8000);

  return () => clearInterval(interval);
}, []);


  return (
    <div className="cyan-page gradient-1">

      {/* Bubbles */}
      <div className="cyan-bubbles">
        {bubbles.map((_, i) => (
          <div key={i} className="bubble"></div>
        ))}
      </div>

      <div className="below-page-content">
        <h1 className="below-top-heading">
          Introducing Rail Robocop - ASC Arjun
        </h1>
      <div className="text-slider-wrapper">
        <div
          className="text-slider"
          style={{ transform: `translateX(-${activeTextSlide * 100}%)` }}
        >
          <p className="text-slide">
            ASC ARJUN is an advanced AI-enabled humanoid RoboCop system officially
            designed, engineered, and developed by Robocoupler Industries Pvt. Ltd., India.
            The robotic system is indigenously manufactured in Visakhapatnam, Andhra Pradesh,
            showcasing India’s innovation and technological self-reliance in Robotics and AI.
          </p>

          <p className="text-slide">
            ASC ARJUN was developed by Robocoupler Industries Pvt. Ltd. in technical collaboration
            with the Railway Protection Force (RPF) for deployment in public safety, surveillance,
            and crowd-management applications. While the RPF serves as the operational deployment partner,
            the core design, AI software, mechanical structure, and integration remain the intellectual
            property of Robocoupler Industries Pvt. Ltd.
          </p>
        </div>
      </div>


        <div className="below-middle-section">
          <div className="below-middle-image">
            <img src="/robocop.png" alt="Robocop" />
          </div>

          <div className="below-cards-container">
            {features.map((feature, i) => (
              <div key={i} className={`below-glass-card card-${i + 1}`}>
                <div className="below-card-content">
                  <h2>{feature.title}</h2>
                  <p>{feature.description}</p>
                </div>
              </div>
            ))}
          </div>

        </div>
      </div>
    </div>
  );
};

export default BelowcontentPage;
